import React, { useEffect, useState } from 'react';
import { TbListCheck, TbBackhoe } from "react-icons/tb";
import { IoDocumentText } from "react-icons/io5";
import '../../CSS/Herramientas.css'
import { useNavigate } from 'react-router';
import { BiUserPlus } from "react-icons/bi";
import { AiOutlineFundProjectionScreen } from "react-icons/ai";
import { RxActivityLog } from "react-icons/rx";
import { FaBuilding, FaRulerCombined, FaTools, FaUsers, FaWarehouse } from "react-icons/fa";
import { BsBricks, BsConeStriped, BsFillDiagram3Fill, BsFillGridFill } from 'react-icons/bs';
import { FaArrowLeftLong, FaBuildingUser } from "react-icons/fa6";
import { getPermission } from '../../Conexiones/Conexion';
import { getApi } from '../../Conexiones/Models';
import { errorMessage } from '../../Utils/AlertMessage';
import Loading from '../../Utils/Loading';

function Catalogos() { 
    /*const catalogos =[
        {id:0,nombre:"Actividades",enlace: "Actividades"} ,
        {id:1,nombre: "Adicionales",enlace: "Adicionales"} ,
        {id:2,nombre: "Trámites",enlace: "Tramites"},
        {id:3,nombre: "Usuarios",enlace: "Usuarios"},
        {id:4,nombre: "Proyectos",enlace: "Tabla-Proyectos"},
        {id:5,nombre:  "Maquinaria y Equipo",enlace: "Maquinaria-Equipo"},
        {id:6,nombre: "Obras y Usuarios",enlace: "Obras-Usuarios"},
        {id:7,nombre: "Bodegas",enlace: "Bodegas"},
        {id:8,nombre: "Tipos de obra",enlace: "Tipos-Obras"},
        {id:9,nombre: "Unidades",enlace: "Unidades"},
        {id:10,nombre: "Empleados",enlace: "Empleados"},
        {id:11,nombre: "Areas",enlace: "Areas"},
        {id:12,nombre: "Puestos",enlace:"Puestos"},
        {id:13,nombre: "Obras",enlace:"Obras"},
        {id:14,nombre: "Materiales",enlace:"Materiales"},
        {id:15,nombre: "Herramientas",enlace:"Herramientas"}
        
    ]*/
    const navigate = useNavigate();
    const usuario = JSON.parse(sessionStorage.getItem('user'));
    const idUsuario = usuario[0].idUsuario;
    const [isLoading,setIsLoading]=useState(false);
    const [catalogo,setCatalogo]=useState([]);

    useEffect (()=>{
        const getCatalogo = async () =>{
            setIsLoading(true);
            const permiso = await getPermission(idUsuario,16)
            if(permiso){
                const endpoint = 'getCatalogos/'+idUsuario;
                const res = await getApi(endpoint);
                if(res.status === 1){
                    if(res.data.length !== undefined){
                        setCatalogo(res.data)
                    }else{
                        errorMessage(res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }else{
                navigate('/inicio')
            }
            setIsLoading(false);
        }
        getCatalogo()
    },[idUsuario,navigate])

    //const icons = [TbListCheck,RxActivityLog,IoDocumentText,BiUserPlus,AiOutlineFundProjectionScreen,TbBackhoe,FaUsers,FaWarehouse,BsConeStriped,FaRulerCombined,FaUser,BsFillGridFill,BsFillDiagram3Fill,FaBuilding,BsBricks,FaTools]
    const icons = [{id:0,icono:TbListCheck},{id:1,icono:RxActivityLog},{id:2,icono:IoDocumentText},{id:3,icono:BiUserPlus},{id:4,icono:AiOutlineFundProjectionScreen},{id:5,icono:TbBackhoe},{id:6,icono:FaBuildingUser},{id:7,icono:FaWarehouse},{id:8,icono:BsConeStriped},{id:9,icono:FaRulerCombined},{id:10,icono:FaUsers},{id:11,icono:BsFillGridFill},{id:12,icono:BsFillDiagram3Fill},{id:13,icono:FaBuilding},{id:14,icono:BsBricks},{id:15,icono:FaTools}]

    const select = (direccion) => {
        navigate(direccion)
    }
    const regresar = () => {
        navigate('/inicio')
    }
    
    return (
        <div className='herramientas' >
            {
                isLoading === true ? 
                <Loading />:
                <div>
                    <div className='contabilidades-header'>
                        <div className='fab'><FaArrowLeftLong className='arrow' onClick={regresar} title='REGRESAR'/></div>
                        <label>CATALOGOS</label>
                    </div>
                    <div style={{padding:'20px', overflowY:'scroll', height:'80vh'}}>
                        <div className="row row-cols-1 row-cols-md-4 g-4" >
                            {
                                catalogo.map((c) =>{
                                    const resultado = icons.filter(d => d.id === c.idModulo);
                                    const Icon = resultado[0].icono
                                    return(                            
                                        <div className="col-sm-6 mb-3 mb-sm-0 " key={c.idModulo}>
                                            <div className='card h-80 btncolor btn' style={{ marginTop: '5px', textAlign: "center", padding:'5px', fontSize:'20px'}} onClick={() => select(c.enlace)}>
                                                <div style={{display:'flex', justifyContent:'space-between'}}>
                                                    <div style={{justifyContent:'center'}}>{c.nomModulo}</div>
                                                    <div style={{fontSize:'40px',justifyContent:'center'}}><Icon/></div>
                                                </div>            
                                            </div>
                                        </div>
                                    )           
                                })
                            }
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}
export default Catalogos;